import type { PartnerResponsible } from 'shared/api/afterSalesApi'
import { INNOSCRIPTA_CHAMPION_RESPONSIBLE_NAME } from 'shared/constants/user'
import type { UserRole } from 'shared/types/user'

import type { RoleOverviewRole } from './components/FullPageOnboarding/components/RoleOverviewScreen/RoleOverviewScreen.types'

const ROLE_OVERVIEW_ROLES: Array<{
  envRoleName: string
  role: RoleOverviewRole
}> = [
  {
    envRoleName: process.env.REACT_APP_PM_ROLE_NAME!,
    role: 'project_manager'
  },
  {
    envRoleName: process.env.REACT_APP_ADMIN_ROLE_NAME!,
    role: 'admin'
  },
  {
    envRoleName: process.env.REACT_APP_FINANZEN_ROLE_NAME!,
    role: 'finance'
  }
]

export const hasInnoscriptaChampionResponsibility = (
  userId: number | undefined,
  responsibles: PartnerResponsible[] | undefined
): boolean =>
  typeof userId === 'number' &&
  Boolean(
    responsibles?.some(
      responsible =>
        responsible.user.id === userId &&
        responsible.responsible_type?.name ===
          INNOSCRIPTA_CHAMPION_RESPONSIBLE_NAME
    )
  )

export const getRoleOverviewRoles = (
  userRoles: UserRole[] = []
): RoleOverviewRole[] =>
  ROLE_OVERVIEW_ROLES.filter(({ envRoleName }) =>
    userRoles.includes(envRoleName)
  ).map(({ role }) => role)
